// Menünün KENDİ arayüz metinleri. Kiracı içeriği (ürün adı, açıklama) buraya girmiyor — o
// Category/Product.translations'ta ve helpers/tenant pickContent ile okunuyor.
//
// Eskiden bu metinler `pickLang(lang, tr, en, ar, ru)` ile KONUMSAL yazılıyordu: beşinci bir dil
// eklemek dokuz çağrının hepsine yeni argüman eklemek demekti.
//
// Gruplama DİLE göre, anahtara göre değil: yeni bir dil eklemek tek blok yapıştırmak. Anahtar sayısı
// altı ve nadiren artıyor; dil sayısı ise kiracının elinde (Language kataloğu 30+). Katalogdaki her
// dilin burada karşılığı var, yani kiracı Almanca'yı açtığında menü tamamen Almanca oluyor —
// yalnızca ürün adları değil.
//
// Dil kodları KÜÇÜK harf, Language tablosundaki `code` ile aynı.
const MESSAGES = {
  tr: {
    "language.select": "Dil seçimi",
    "product.new": "YENİ",
    "product.expandImage": "görseli büyüt",
    "price.updatedAt": "Fiyat Güncelleme Tarihi",
    "branches.title": "Şubelerimiz",
    "branches.map": "harita",
    "review.cta": "Deneyimini paylaş",
  },
  en: {
    "language.select": "Language selection",
    "product.new": "NEW",
    "product.expandImage": "expand image",
    "price.updatedAt": "Price Updated Date",
    "branches.title": "Our Stores",
    "branches.map": "map",
    "review.cta": "Share your visit",
  },
  ar: {
    "language.select": "اختيار اللغة",
    "product.new": "جديد",
    "product.expandImage": "تكبير الصورة",
    "price.updatedAt": "تاريخ تحديث السعر",
    "branches.title": "فروعنا",
    "branches.map": "خريطة",
    "review.cta": "شاركنا رأيك",
  },
  ru: {
    "language.select": "Выбор языка",
    "product.new": "НОВОЕ",
    "product.expandImage": "увеличить изображение",
    "price.updatedAt": "Дата обновления цен",
    "branches.title": "Наши филиалы",
    "branches.map": "карта",
    "review.cta": "Ваш отзыв",
  },
  de: {
    "language.select": "Sprachauswahl",
    "product.new": "NEU",
    "product.expandImage": "Bild vergrößern",
    "price.updatedAt": "Preis aktualisiert am",
    "branches.title": "Unsere Filialen",
    "branches.map": "Karte",
    "review.cta": "Erlebnis teilen",
  },
  fr: {
    "language.select": "Choix de la langue",
    "product.new": "NOUVEAU",
    "product.expandImage": "agrandir l'image",
    "price.updatedAt": "Prix mis à jour le",
    "branches.title": "Nos établissements",
    "branches.map": "carte",
    "review.cta": "Votre avis",
  },
  es: {
    "language.select": "Selección de idioma",
    "product.new": "NUEVO",
    "product.expandImage": "ampliar imagen",
    "price.updatedAt": "Precio actualizado el",
    "branches.title": "Nuestras tiendas",
    "branches.map": "mapa",
    "review.cta": "Comparte tu visita",
  },
  it: {
    "language.select": "Selezione lingua",
    "product.new": "NUOVO",
    "product.expandImage": "ingrandisci immagine",
    "price.updatedAt": "Prezzo aggiornato il",
    "branches.title": "I nostri punti vendita",
    "branches.map": "mappa",
    "review.cta": "Racconta la visita",
  },
  nl: {
    "language.select": "Taalkeuze",
    "product.new": "NIEUW",
    "product.expandImage": "afbeelding vergroten",
    "price.updatedAt": "Prijs bijgewerkt op",
    "branches.title": "Onze vestigingen",
    "branches.map": "kaart",
    "review.cta": "Deel je ervaring",
  },
  pt: {
    "language.select": "Seleção de idioma",
    "product.new": "NOVO",
    "product.expandImage": "ampliar imagem",
    "price.updatedAt": "Preço atualizado em",
    "branches.title": "As nossas lojas",
    "branches.map": "mapa",
    "review.cta": "Partilhe a visita",
  },
  pl: {
    "language.select": "Wybór języka",
    "product.new": "NOWOŚĆ",
    "product.expandImage": "powiększ zdjęcie",
    "price.updatedAt": "Data aktualizacji cen",
    "branches.title": "Nasze lokale",
    "branches.map": "mapa",
    "review.cta": "Podziel się opinią",
  },
  uk: {
    "language.select": "Вибір мови",
    "product.new": "НОВЕ",
    "product.expandImage": "збільшити зображення",
    "price.updatedAt": "Дата оновлення цін",
    "branches.title": "Наші заклади",
    "branches.map": "карта",
    "review.cta": "Ваш відгук",
  },
  ro: {
    "language.select": "Selectare limbă",
    "product.new": "NOU",
    "product.expandImage": "mărește imaginea",
    "price.updatedAt": "Preț actualizat la",
    "branches.title": "Locațiile noastre",
    "branches.map": "hartă",
    "review.cta": "Spune-ne părerea",
  },
  bg: {
    "language.select": "Избор на език",
    "product.new": "НОВО",
    "product.expandImage": "увеличи изображението",
    "price.updatedAt": "Дата на актуализация на цените",
    "branches.title": "Нашите обекти",
    "branches.map": "карта",
    "review.cta": "Вашето мнение",
  },
  el: {
    "language.select": "Επιλογή γλώσσας",
    "product.new": "ΝΕΟ",
    "product.expandImage": "μεγέθυνση εικόνας",
    "price.updatedAt": "Ημερομηνία ενημέρωσης τιμών",
    "branches.title": "Τα καταστήματά μας",
    "branches.map": "χάρτης",
    "review.cta": "Η γνώμη σας",
  },
  sr: {
    "language.select": "Избор језика",
    "product.new": "НОВО",
    "product.expandImage": "увећај слику",
    "price.updatedAt": "Датум ажурирања цена",
    "branches.title": "Наши локали",
    "branches.map": "мапа",
    "review.cta": "Поделите утисак",
  },
  cs: {
    "language.select": "Výběr jazyka",
    "product.new": "NOVINKA",
    "product.expandImage": "zvětšit obrázek",
    "price.updatedAt": "Datum aktualizace cen",
    "branches.title": "Naše pobočky",
    "branches.map": "mapa",
    "review.cta": "Váš dojem",
  },
  hu: {
    "language.select": "Nyelvválasztás",
    "product.new": "ÚJ",
    "product.expandImage": "kép nagyítása",
    "price.updatedAt": "Árak frissítve",
    "branches.title": "Üzleteink",
    "branches.map": "térkép",
    "review.cta": "Mondja el",
  },
  sv: {
    "language.select": "Språkval",
    "product.new": "NYHET",
    "product.expandImage": "förstora bild",
    "price.updatedAt": "Priser uppdaterade",
    "branches.title": "Våra restauranger",
    "branches.map": "karta",
    "review.cta": "Dela din åsikt",
  },
  da: {
    "language.select": "Sprogvalg",
    "product.new": "NY",
    "product.expandImage": "forstør billede",
    "price.updatedAt": "Priser opdateret",
    "branches.title": "Vores restauranter",
    "branches.map": "kort",
    "review.cta": "Del din oplevelse",
  },
  no: {
    "language.select": "Språkvalg",
    "product.new": "NY",
    "product.expandImage": "forstørr bilde",
    "price.updatedAt": "Priser oppdatert",
    "branches.title": "Våre restauranter",
    "branches.map": "kart",
    "review.cta": "Del opplevelsen",
  },
  fi: {
    "language.select": "Kielen valinta",
    "product.new": "UUSI",
    "product.expandImage": "suurenna kuva",
    "price.updatedAt": "Hinnat päivitetty",
    "branches.title": "Ravintolamme",
    "branches.map": "kartta",
    "review.cta": "Jaa kokemuksesi",
  },
  az: {
    "language.select": "Dil seçimi",
    "product.new": "YENİ",
    "product.expandImage": "şəkli böyüt",
    "price.updatedAt": "Qiymət yenilənmə tarixi",
    "branches.title": "Filiallarımız",
    "branches.map": "xəritə",
    "review.cta": "Təəssüratını bölüş",
  },
  ka: {
    "language.select": "ენის არჩევა",
    "product.new": "ახალი",
    "product.expandImage": "სურათის გადიდება",
    "price.updatedAt": "ფასების განახლების თარიღი",
    "branches.title": "ჩვენი ფილიალები",
    "branches.map": "რუკა",
    "review.cta": "გაგვიზიარეთ",
  },
  kk: {
    "language.select": "Тіл таңдау",
    "product.new": "ЖАҢА",
    "product.expandImage": "суретті үлкейту",
    "price.updatedAt": "Баға жаңарту күні",
    "branches.title": "Біздің филиалдар",
    "branches.map": "карта",
    "review.cta": "Пікіріңіз",
  },
  fa: {
    "language.select": "انتخاب زبان",
    "product.new": "جدید",
    "product.expandImage": "بزرگ‌نمایی تصویر",
    "price.updatedAt": "تاریخ به‌روزرسانی قیمت",
    "branches.title": "شعب ما",
    "branches.map": "نقشه",
    "review.cta": "تجربه‌تان را بگویید",
  },
  he: {
    "language.select": "בחירת שפה",
    "product.new": "חדש",
    "product.expandImage": "הגדל תמונה",
    "price.updatedAt": "תאריך עדכון מחירים",
    "branches.title": "הסניפים שלנו",
    "branches.map": "מפה",
    "review.cta": "שתפו את החוויה",
  },
  ur: {
    "language.select": "زبان کا انتخاب",
    "product.new": "نیا",
    "product.expandImage": "تصویر بڑی کریں",
    "price.updatedAt": "قیمت اپ ڈیٹ کی تاریخ",
    "branches.title": "ہماری شاخیں",
    "branches.map": "نقشہ",
    "review.cta": "اپنا تجربہ بتائیں",
  },
  zh: {
    "language.select": "语言选择",
    "product.new": "新品",
    "product.expandImage": "放大图片",
    "price.updatedAt": "价格更新日期",
    "branches.title": "我们的门店",
    "branches.map": "地图",
    "review.cta": "分享你的体验",
  },
  ja: {
    "language.select": "言語選択",
    "product.new": "新着",
    "product.expandImage": "画像を拡大",
    "price.updatedAt": "価格更新日",
    "branches.title": "店舗一覧",
    "branches.map": "地図",
    "review.cta": "感想をシェア",
  },
  ko: {
    "language.select": "언어 선택",
    "product.new": "신메뉴",
    "product.expandImage": "이미지 확대",
    "price.updatedAt": "가격 업데이트 날짜",
    "branches.title": "매장 안내",
    "branches.map": "지도",
    "review.cta": "방문 후기 남기기",
  },
  hi: {
    "language.select": "भाषा चयन",
    "product.new": "नया",
    "product.expandImage": "छवि बड़ी करें",
    "price.updatedAt": "मूल्य अद्यतन तिथि",
    "branches.title": "हमारे स्टोर",
    "branches.map": "मानचित्र",
    "review.cta": "अनुभव साझा करें",
  },
  id: {
    "language.select": "Pilih bahasa",
    "product.new": "BARU",
    "product.expandImage": "perbesar gambar",
    "price.updatedAt": "Harga diperbarui",
    "branches.title": "Gerai kami",
    "branches.map": "peta",
    "review.cta": "Bagikan kesan",
  },
  th: {
    "language.select": "เลือกภาษา",
    "product.new": "ใหม่",
    "product.expandImage": "ขยายรูปภาพ",
    "price.updatedAt": "วันที่อัปเดตราคา",
    "branches.title": "สาขาของเรา",
    "branches.map": "แผนที่",
    "review.cta": "แบ่งปันประสบการณ์",
  },
};

// Yedek zinciri: seçilen dil → İNGİLİZCE → Türkçe.
//
// İngilizce ortada duruyor çünkü Türkçe'ye düşmek yanlış tarafa düşmek: kullanıcı Almanca'yı
// seçerek zaten "Türkçe okuyamıyorum" demiş oluyor. Katalogda olup burada karşılığı olmayan bir dil
// (biri Language tablosuna satır ekleyip sözlüğü unutursa) böylece Türkçe değil İngilizce görüyor.
const FALLBACKS = ["en", "tr"];

const warned = new Set();

export const t = (lang, key) => {
  if (import.meta.env.DEV && lang && !MESSAGES[lang] && !warned.has(lang)) {
    warned.add(lang);
    // Katalogda var, sözlükte yok. Menü İngilizce'ye düşerek çalışmaya devam ediyor ama bu
    // sessizce olursa kimse fark etmiyor.
    console.warn(`[menu] "${lang}" için arayüz sözlüğü yok — src/i18n'e ekle`);
  }

  for (const code of [lang, ...FALLBACKS]) {
    const value = MESSAGES[code]?.[key];

    if (value) {
      return value;
    }
  }

  // Anahtarın kendisi ekranda görünür ve hangi çevirinin eksik olduğunu söyler; sessizce boş
  // string basmak metni yok eder.
  return key;
};
